// [pipChat] ODS e ODP (LibreOffice Calc e Impress) onde o ODT já passa.
//
// O `getAllowedFileTypesByChannel` do `@chatwoot/utils` monta a lista de tipos
// aceitos por canal e esqueceu as duas: o Writer (ODT) passa e a planilha é
// recusada com "tipo de arquivo não permitido" — sem explicação possível para
// quem só queria anexar um orçamento feito no Calc. Pedido do Felipe (11/09).
//
// ⚠️ A regra é deliberadamente AMARRADA AO ODT, e não um append cego: cada
// canal tem a sua lista (o WhatsApp aceita bem menos que o e-mail, porque quem
// manda é o provedor). Acrescentando só onde o ODT já é aceito, a permissão
// acompanha sozinha o que cada canal permite — inclusive quando o upstream
// mudar essas listas num merge futuro.
//
// ⚠️ As EXTENSÕES vão junto dos MIMEs porque nem todo navegador sabe o tipo de
// um arquivo ODF: quando ele manda `application/octet-stream`, quem decide é a
// extensão. Sem isso, a mesma planilha passa ou não dependendo de quem envia.
import { getAllowedFileTypesByChannel } from '@chatwoot/utils';

const MARCA_DO_ODT = 'opendocument.text';

const EXTRAS_ODF = [
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',
  '.ods',
  '.odp',
];

export const tiposDeArquivoAceitos = opcoes => {
  const lista =
    opcoes === undefined
      ? getAllowedFileTypesByChannel()
      : getAllowedFileTypesByChannel(opcoes);

  if (!lista || !lista.includes(MARCA_DO_ODT)) return lista;

  const faltando = EXTRAS_ODF.filter(tipo => !lista.includes(tipo));
  return faltando.length ? `${lista},${faltando.join(',')}` : lista;
};

export default tiposDeArquivoAceitos;
